export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_ALREADY_CHECK_SESSION = "SET_ALREADY_CHECK_SESSION";

